const colors = {
  white: '#fff',
  blue: '#0085c7',
  veryLightBlue: '#f4f8fc',
  blueGray: '#80adbf',
  lightGray: '#eaeaea',
  gray: '#d7d7d7',
  yellow: '#FFEB3B',
  lightYellow: '#fff59d',
  orange: '#FF9800',
  lightOrange: '#FDD835',
  red: '#FF5722',
  lightRed: '#ef9a9a',
  darkRed: '#b71c1c',
  veryDarkRed: '#861111',
  lime: '#cddc39',
  lightEmerald: '#e0f2f1',
  emerald: '#149c82',
  lightGreen: '#C5E1A5',
  green: '#8bc34a',
  darkGreen: '#558b2f',
  veryDarkGreen: '#1b5e20',
  black: '#1a242f',
  mobileGreen: '#58B99D',
};

export default colors;
